export default __webpack_public_path__ + "static/media/client.858fc573.svg";